var borderWidths = {
  thinner: '0.5px',
  thin: '0.75px',
  "default": '1px',
  thick: '2px',
  thicker: '4px'
};

export { borderWidths };
//# sourceMappingURL=border-widths.esm.js.map
